<template>
    <div class="our-people">
        <div class="container">
            <div class="aligncenter top-text" v-html="heading_text"></div>
            <div class="our-people-swiper-container swiper-container wide-slider">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" :key="index" v-for="(slide, index) in slides">
                        <a class="box">
                            <div
                                class="bg"
                                :style="{ 'background-image': 'url( '+ slide.image.url +' )'}"
                            ></div>
                            <div class="text">
                                <div class="name">{{slide.name}}</div>
                                <div class="status">{{slide.status}}</div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="our-people-swiper-prev wide-slider-prev"></div>
                <div class="our-people-swiper-next wide-slider-next"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["blockdata"],
    name: "our-people-slider",
    data() {
        return {
            heading_text: this.blockdata.heading_text,
            slides: this.blockdata.slides
        };
    },
    mounted: function() {
        var ourPeopleSwiper = new Swiper(".our-people-swiper-container", {
            loop: true,
            slidesPerView: "auto",
            centeredSlides: true,
            initialSlide: 1,
            spaceBetween: 5,
            nextButton: ".our-people-swiper-next",
            prevButton: ".our-people-swiper-prev",
            speed: 500
        });
    }
};
</script>


// WEBPACK FOOTER //
// OurPeopleSlider.vue?4f88876f